import React, { ReactElement } from 'react';
import './styles.scss';

export default function PageLoader(): ReactElement {
  return (
    <div className='page-loader'>
      <div id='dots1'>
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
